<template>
  <section
    class="typeahead-input"
    v-on:keyup.down="downPress"
    v-on:keyup.up="upPress"
  >
    <!-- 1 line below is a hack.  Not sure why but typeahead will only
    be respected if inputedLocation is rendered in the template-->
    <span style="display:none;">{{ inputedLocation }}</span>
    <slot />
    <div v-if="list.length > 0 && showTypeahead">
      <button class="close iconclose" @click="showTypeahead = false"></button>
      <ul>
        <li v-for="entity in list" :key="entity.id">
          <router-link
            :to="
              `${typeaheadBaseLink}${entity.item.Lat.$numberDecimal ||
                entity.item.Lat},${entity.item.Lng.$numberDecimal ||
                entity.item.Lng}`
            "
            @click.native="fetchForLink"
          >
            {{ entity.item.City }}, {{ entity.item.Region }},
            {{ entity.item.Country }}
          </router-link>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { memoize } from "@/utils/memoize";
import axios from "axios";
import {
  sortClosest,
  removeDuplicatesArrObj,
  removeDuplicatesArrObjectMultiple
} from "@/utils/arrays";
import Vue from "vue";
export default {
  name: "TypeAhead",
  props: ["fetchUrl", "inputedLocation", "typeaheadBaseLink"],
  data() {
    return {
      list: [],
      showTypeahead: false
    };
  },

  updated() {
    if (this.inputedLocation.length === 0) {
      this.showTypeahead = false;
      return;
    } else if (this.inputedLocation.length > 2) {
      this.suggest();
    }
  },

  methods: {
    fetchForLink() {
      this.showTypeahead = false;
      this.$emit("fetchForLink");
      this.list = [];
    },

    suggest() {
      const context = this;
      var rf = debounce(function() {
        const url = context["fetchUrl"];
        memoize(url, axios.get, [url]).then(d => {
          /// need to change this so it checks both Region and City properties, not just region
          removeDuplicatesArrObjectMultiple(d.data, ["City", "Region"]);
          const rdups = removeDuplicatesArrObjectMultiple(d.data, [
            "City",
            "Region"
          ]).map(item => {
            item.Lat = item.Lat.$numberDecimal || item.Lat;
            item.Lng = item.Lng.$numberDecimal || item.Lng;
            return item;
          });
          const list = sortClosest(
            rdups,
            ["Lat", "Lng"],
            [
              context.$attrs.lat.$numberDecimal || context.$attrs.lat,
              context.$attrs.lng.$numbrDecimal || context.$attrs.lng
            ]
          );
          context["list"] = list;
          context["showTypeahead"] = true;
        });
      }, 500);

      rf();
    },

    downPress(e) {
      const activeItem = e.target;
      const anchorItems = Array.prototype.slice
        .call(this.$el.querySelectorAll("li a"))
        .map(item => item);

      const activeItemIndex = anchorItems.indexOf(activeItem);
      const selectedItemIndex = activeItemIndex + 1;
      if (selectedItemIndex < anchorItems.length) {
        anchorItems[selectedItemIndex].focus();
      } else {
        anchorItems[0].focus();
      }
    },

    upPress(e) {
      const activeItem = e.target;
      const anchorItems = Array.prototype.slice
        .call(this.$el.querySelectorAll("li a"))
        .map(item => item);

      const activeItemIndex = anchorItems.indexOf(activeItem);
      const selectedItemIndex = activeItemIndex - 1;
      if (selectedItemIndex > -1) {
        anchorItems[selectedItemIndex].focus();
      } else {
        anchorItems[anchorItems.length - 1].focus();
      }
    }
  }
};
</script>

<style>
.typeahead-input div {
  background: white;
  z-index: 1000;
  position: relative;
  width: 320px;
  padding: 12px;
  font-size: 0.9rem;
  text-align: left;
  left: 65px;
  border: 1px solid #c53526;
  max-height: calc(100% - 50px);
  overflow-y: scroll;
}

.typeahead-input .close {
  display: block;
}
.typeahead-input li {
  list-style: none;
}

.typeahead-input li a {
  padding: 3px;
}

.typeahead-input li a:focus {
  border: 1px dotted gray;
}

@media screen and (min-width: 0px) and (max-width: 375px) {
  .typeahead-input div {
    left: 0;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
